<template>
  <div class="card_ticket_S ticket_detail_right">
    <addRespnse @reload-table-data="reloadSearch" ref="childComponentTeamRef" />
  </div>
  <div class="card border-0 ticketx_mainlisting">
    <div class="card-body p-0">
      <div class="right-bodypart pageTblHeightCls">
        <div class="Setcard_row">
          <div class="card_ticket_S ticket_detail_left">
            <div
              class="card_ticket_header d-flex align-items-center justify-content-between"
            >
              <span class="d-flex align-items-center forpleftsktitle">
                <i v-b-tooltip.hover v-bind:title="ticketInfo.title">{{
                  ticketInfo.title
                }}</i>
              </span>
              <div class="forpleftsk d-flex">
                <Select2
                  class="me-2"
                  v-model="priorityId"
                  v-bind:id="'priorityId'"
                  :options="$store.state.priority.PriorityList"
                  :placeholder="'Select Priority'"
                  @change="myChangeEventPriority($event)"
                  @select="mySelectEventPriority($event)"
                />
                <Select2
                  v-model="labelId"
                  v-bind:id="'labelId'"
                  :options="$store.state.labels.LabelsList"
                  :placeholder="'Select Label'"
                  @change="myChangeEventLabels($event)"
                  @select="mySelectEventLabel($event)"
                />
              </div>
            </div>
            <div class="card_ticket_body">
              <label class="d-flex">
                <span>User</span>
                <b
                  ><router-link :to="`/tickets?name=${ticketInfo.user_id}`">{{
                    ticketInfo.user_id
                  }}</router-link></b
                >
              </label>
              <label class="d-flex">
                <span>Ticket Id</span>
                <b>{{ ticketInfo.ticket_id }}</b>
              </label>
              <label class="d-flex">
                <span>Submitted</span>
                <b v-b-tooltip.hover v-bind:title="formatDateTime(ticketInfo.createdAt)">
                  <timeago
                    v-if="ticketInfo.createdAt"
                    :datetime="new Date(ticketInfo.createdAt)"
                  />
                </b>
              </label>
            </div>
            <div class="card_ticket_detai">
              <p
                class="cursor"
                v-html="
                  formatIssue(
                    isExpanded[111] ? ticketInfo.issue : truncatedText(ticketInfo.issue)
                  )
                "
                @click="toggleExpand(111)"
              ></p>
              <button
                v-if="ticketInfo.issue && ticketInfo.issue.length > limit"
                @click="toggleExpand(111)"
                class="d-none"
              >
                {{ isExpanded[111] ? "Read Less" : "Read More" }}
              </button>
              <ul>
                <li v-for="item in ticketInfo.attachments" :key="item._id">
                  <a
                    :href="img_url + item"
                    download
                    target="_blank"
                    class="pdf-download"
                    v-if="item.toLowerCase().endsWith('.pdf')"
                  >
                    <img
                      class="cursor"
                      src="../../../assets/images/default-pdf.png"
                      alt="Download PDF"
                    />
                    <span>Download PDF</span>
                  </a>
                  <img
                    class="cursor"
                    :class="'img' + item"
                    :src="getImageSrc(item)"
                    @error="imageLoadError(item)"
                    @click="showSingle(img_url + '' + item)"
                    v-else
                  />
                </li>
              </ul>
            </div>
            <div
              class="card_ticket_detai"
              v-if="ticketInfo.label == 'Resolved' && ticketInfo.rating"
            >
              <div
                class="rating-wrapper d-flex align-items-center justify-content-center mb-2"
              >
                <span
                  v-for="star in ticketInfo.rating"
                  :key="star"
                  class="star cursor active"
                  :class="{ active: isHovering ? star <= hoverIndex : star <= rating }"
                  aria-role="button"
                  :aria-label="`Rate ${star} star`"
                  >★</span
                >
              </div>
              <div class="feedback-wrapper">
                {{ ticketInfo.feedback }}
              </div>
            </div>
            <div class="query_and_response_main" id="pageHeighScrollCls">
              <div
                class="querysetboxcls"
                v-for="item in ticketInfo.responses"
                :key="item._id"
                :class="item.is_user == 0 ? 'userResponder' : 'responder'"
              >
                <div class="query_and_response_inner">
                  <div class="responder_datetime">
                    <h6>{{ item.is_user == 0 ? ticketInfo.user_id : "Admin" }}</h6>
                    <p
                      class="m-0"
                      v-b-tooltip.hover
                      v-bind:title="formatDateTime(item.createdAt)"
                    >
                      <timeago :datetime="item.createdAt" />
                    </p>
                  </div>
                  <p
                    class="cursor"
                    v-html="
                      formatIssue(
                        isExpanded[item._id]
                          ? item.response
                          : truncatedText(item.response)
                      )
                    "
                    @click="toggleExpand(item._id)"
                  ></p>
                  <button
                    v-if="item.response.length > limit"
                    @click="toggleExpand(item._id)"
                    class="d-none"
                  >
                    {{ isExpanded[item._id] ? "Read Less" : "Read More" }}
                  </button>
                  <ul v-if="item.attachments.length > 0">
                    <li v-for="itemLi in item.attachments" :key="itemLi._id">
                      <a
                        :href="img_url + itemLi"
                        download
                        target="_blank"
                        class="pdf-download"
                        v-if="itemLi.toLowerCase().endsWith('.pdf')"
                      >
                        <img
                          class="cursor"
                          src="../../../assets/images/default-pdf.png"
                          alt="Download PDF"
                        />
                        <span>Download PDF</span>
                      </a>
                      <img
                        class="cursor"
                        :class="'img' + itemLi"
                        :src="getImageSrc(itemLi)"
                        @error="imageLoadError(itemLi)"
                        @click="showSingle(img_url + '' + itemLi)"
                        v-else
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="hidden" class="ticketId" :value="this.ticketId" id="ticketId" />
  </div>
  <PriorityData />
  <LabelsData />
  <vue-easy-lightbox
    :visible="visibleRef"
    :imgs="imgsRef"
    :index="indexRef"
    @hide="onHide"
  ></vue-easy-lightbox>
</template>
<script>
import Select2 from "vue3-select2-component";
import PriorityData from "../priority/PriorityData.vue";
import LabelsData from "../labels/LabelsData.vue";
import VueEasyLightbox from "vue-easy-lightbox";

import { useVuelidate } from "@vuelidate/core";
import addRespnse from "./addRespnse.vue";
import axios from "axios";
import { required, minLength } from "@vuelidate/validators";
import { decodeBase62, formatDateTime } from "../../../helper.js";
import $ from "jquery";
import { ref } from "vue";
export default {
  name: "TicketDetailPage",
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      windowWidth: window.innerWidth,
      ticketId: "",
      priorityId: "",
      labelId: "",
      ticketInfo: [],
      isExpanded: {},
      limit: 150,

      loginLoader: 1,
      file: [], // Holds uploaded files
      files: [],
      myFiles: [],
      errorMessage: "",
      errorRes: "",
      isResonsiveCls: 1,
      form: {
        issue: "",
      },
    };
  },
  components: {
    Select2,
    PriorityData,
    LabelsData,
    VueEasyLightbox,
    addRespnse,
  },
  async mounted() {
    this.$store.state.pageTitle = "Tickets Detail";
    if (this.$route.params.ticketId == "") {
      this.$router.push({ path: "/" });
    } else {
      if (this.windowWidth < 991) {
        this.isResonsiveCls = 2;
        // $('.resToggleCls').addClass("resToggleMainCls");
        $(".resToggleCls").removeClass("sideMenuActive");
        // $('.resToggleCls').slideToggle('normal',function(){ $(this).toggleClass('displayBlock displayNone');});
      }
      this.ticketId = this.decodeBase62(this.$route.params.ticketId);
      this.ticketDetail();
    }
  },
  methods: {
    decodeBase62,
    formatDateTime,
    startLoader() {
      this.$Progress.start();
    },
    finishLoader() {
      this.$Progress.finish();
    },
    myChangeEventPriority(val) {
      this.priorityId = val;
      this.changePriority();
    },
    mySelectEventPriority({ id, text }) {
      console.log({ id, text });
      this.priorityId = id;
      this.changePriority();
    },
    myChangeEventLabels(val) {
      console.log(val);
      this.labelId = val;
      this.changeLabels();
    },
    mySelectEventLabel({ id, text }) {
      console.log({ id, text });
      this.labelId = id;
      this.changeLabels();
    },
    async changePriority() {
      if (this.ticketId) {
        this.pageLoader = 2;
        this.startLoader();
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$store.state.user.accessToken;
        await axios
          .post(process.env.VUE_APP_API_URL + "ticket/change-priority", {
            ticket_id: this.ticketId,
            priority_id: this.priorityId,
          })
          .then((resp) => {
            console.log(resp);
            if (resp.status == 200 && resp.data.status == "success") {
              this.$toast.success(resp.data.message);
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
            console.log("response", error.response.status);
            console.log("message", error.response.data.message);
            this.formLoader = 1;
          });
      }
    },
    async changeLabels() {
      if (this.ticketId) {
        this.pageLoader = 2;
        this.startLoader();
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$store.state.user.accessToken;
        await axios
          .post(process.env.VUE_APP_API_URL + "ticket/change-label", {
            ticket_id: this.ticketId,
            label_id: this.labelId,
          })
          .then((resp) => {
            if (resp.status == 200 && resp.data.status == "success") {
              this.$toast.success(resp.data.message);
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
            console.log("response", error.response.status);
            console.log("message", error.response.data.message);
            this.formLoader = 1;
          });
      }
    },
    async ticketDetail() {
      if (this.ticketId) {
        this.pageLoader = 2;
        this.startLoader();
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + this.$store.state.user.accessToken;
        await axios
          .post(process.env.VUE_APP_API_URL + "ticket/detail", {
            ticket_id: this.ticketId,
          })
          .then((resp) => {
            if (resp.status == 200 && resp.data.status == "success") {
              this.$toast.success(resp.data.message);
              this.ticketInfo = resp.data.data;
              this.priorityId = resp.data.data.priority_id;
              this.labelId = resp.data.data.label_id;
              this.$store.state.pageTitle =
                "Tickets Detail: #" + this.ticketInfo.ticket_id;
              this.pageScroll();
              this.finishLoader();
            }
          })
          .catch((error) => {
            // this.errorMessage = error.message;
            console.error("There was an error!", error);
            console.log("response", error.response.status);
            console.log("message", error.response.data.message);
            this.formLoader = 1;
            // this.errorRes = error.response.data.message;
          });
      }
    },
    getImageSrc(filePath) {
      if (filePath.toLowerCase().endsWith(".pdf")) {
        return require("@/assets/images/default-pdf.png");
      }
      return this.img_url + filePath; // Return original image path
    },
    imageLoadError(item) {
      console.log("Image failed to load");
      $(".userImgSideCls").hide(".img", item);
    },
    formatIssue(text) {
      if (!text) return ""; // Prevent errors if issue is undefined or null
      return text.replace(/\r\n|\n/g, "<br>");
    },
    toggleExpand(id) {
      this.isExpanded = { ...this.isExpanded, [id]: !this.isExpanded[id] };
      // this.$set(this.isExpanded, id, !this.isExpanded[id]); // Toggle state per ticket
    },
    truncatedText(issue) {
      if (!issue || typeof issue !== "string") {
        return ""; // Handle undefined/null cases
      }
      // return issue.substring(0, this.limit) + " ..." +this.limit;
      return issue.length > this.limit
        ? issue.substring(0, this.limit) +
            "... <span class='readmorecls'>Read more</span>"
        : issue;
    },
    updateFiles(newFiles) {
      this.files = newFiles.map((file) => file.file);
    },
    async submitAddTicket() {
      $(".fdRsCls").toggleClass("resToggleMainCls");
      $(".fdRsNonCls").toggleClass("resToggleMainNoneCls");
      // $('.resToggleCls').slideToggle();
      $(".resToggleCls").slideToggle("normal", function () {
        $(this).toggleClass("displayBlock displayNone");
      });
    },
    async pageScroll() {
      const element = document.getElementById("pageHeighScrollCls");
      element.scrollTo({
        top: element.scrollHeight,
        behavior: "smooth",
      });
    },
    async reloadSearch() {
      this.ticketDetail();
    },
  },
  setup() {
    const visibleRef = ref(false);
    const childComponentTeamRef = ref(null);
    const indexRef = ref(0);
    const imgsRef = ref([]);
    const onShow = () => {
      visibleRef.value = true;
    };
    const showSingle = (itemCmt) => {
      imgsRef.value = [
        { title: "", src: itemCmt },
        // { title: itemCmt.file_name, src: itemCmt.file_url },
      ];
      onShow();
    };
    const onHide = () => (visibleRef.value = false);

    const pond = ref(null); // Reference to FilePond

    const removeAllFiles = () => {
      if (pond.value) {
        pond.value.removeFiles(); // Remove all files
      }
    };

    return {
      childComponentTeamRef,
      visibleRef,
      indexRef,
      imgsRef,
      showSingle,
      onHide,
      v$: useVuelidate(),
      pond,
      removeAllFiles,
    };
  },
  validations() {
    return {
      form: {
        issue: {
          required,
          min: minLength(2),
        },
      },
    };
  },
};
</script>
<style scoped>
.rating-wrapper {
  user-select: none;
}
.star {
  font-size: 36px;
  color: #e0e0e0;
  margin: 0 4px;
  transition: color 0.15s ease, transform 0.1s ease;
  display: inline-block;
}
.star:hover {
  transform: scale(1.1);
}

/* Selected stars: rely only on the active class set by Vue */
.star.active {
  color: #f5b301;
}
.star.preview {
  color: #ffd766;
}

/* Hover preview color handled via class binding; keep base styles simple */

.rating-wrapper .star:not(.active):not(:hover) {
  cursor: pointer;
}
.feedback-wrapper .form-control {
  border-radius: 8px;
  min-height: 120px;
  resize: vertical;
}
</style>
